import React, { useState, useEffect, useRef } from 'react';

import classNames from 'classnames';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import '../../../components/Crud.scss';
import * as _ from 'lodash';
import { ProgressBar } from 'primereact/progressbar';
import { v4 as uuidv4 } from 'uuid';
import {Checkbox} from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';
import { Paginator } from 'primereact/paginator';
import { PickList } from 'primereact/picklist';

import { SubscriptionService } from '../services/SubscriptionService';
import { SubscriptionPlanService } from '../services/SubscriptionPlanService';
import { EntityService } from "../../../service/EntityService";
import { LanguageService } from "../../../service/LanguageService";
import { Fieldset } from 'primereact/fieldset';
import { InputMask } from 'primereact/inputmask';
import { SelectButton } from 'primereact/selectbutton';
import { AuthorizationService } from '../../../service/AuthorizationService';

import { useMercadopago } from 'react-sdk-mercadopago';

function CurrentSubscription() {

    const subscriptionService = new SubscriptionService();
    const subscriptionPlanService = new SubscriptionPlanService();
    const languageService = new LanguageService();
    const authorizationService = new AuthorizationService();
    
    const [currentSubscriptions, setCurrentSubscriptions] = useState(null);
    const [subscriptionPlans, setSubscriptionPlans] = useState([]);
    const [currentCustomer, setCurrentCustomer] = useState({ client_id: authorizationService.getCurrentUser().client.id, type: "PJ", address: {}});
    const [tenant, setTenant] = useState(authorizationService.getCurrentUser().client);
    
    const [loading, setLoading] = useState(true);
    const [showDetails, setShowDetails] = useState(false);
    const [itemToDetail, setItemToDetail] = useState({ config: {}});

    const [showCustomerCreation, setShowCustomerCreation] = useState(false);
    const [saving, setSaving] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const [showSubscriptionConfirmation, setShowSubscriptionConfirmation] = useState(false);
    const [showPaymentScreen, setShowPaymentScreen] = useState(false);
    const [subscriptionEnded, setSubscriptionEnded] = useState(false);

    const toast = useRef(null);

    const mp = useMercadopago.v2('APP_USR-e9a32ad0-5df0-49cc-9173-293b114a84ac', {
        locale: 'en-US'
    });

    //http://localhost:3000/greener/subscriptions/current-subscription?transaction_id=C345D88E-98BD-4538-A3B0-4441B2002B50

    useEffect(() => {

        async function fetchData() {

            setCurrentCustomer(Object.assign(currentCustomer, await subscriptionService.getCurrentCustomer()));
            setCurrentSubscriptions(await subscriptionService.getCurrentSubscriptions());
            setLoading(false);
        }        
        fetchData();
    }, []);

    const checkStatus = async () => {
        setSaving(true);
        setCurrentSubscriptions(await subscriptionService.getCurrentSubscriptions());
        setSaving(false);
    }

    const cancelPendingPayment = async (subscription) => {
        setSaving(true);
        setCurrentSubscriptions(await subscriptionService.abortSubscription(subscription.id));
        setSaving(false);
    }

    const cancelActive = async (subscription) => {
        setSaving(true);
        setCurrentSubscriptions(await subscriptionService.cancelSubscription(subscription.id));
        setSaving(false);
    }

    return (
        <div className="datatable-crud-demo">
            <Toast ref={toast} />
            <div className="card">
                { loading && <ProgressBar mode="indeterminate"/> }
                { !loading &&
                <>
                <Toolbar className="p-mb-4" left={<h5 className="p-m-0">Minha Assinatura</h5>}></Toolbar>
                {
                    currentSubscriptions.sort((a,b) => a.config.status === "ACTIVE" ? -1 : 1).map(subscription => 
                        <div key={`current_plan${subscription.id}`} className="card summary p-grid" style={{border: '1px solid #ccc', margin: '0px', marginBottom: '10px'}}>
                            <div className="p-col-12"><b>{subscription.config.plan.name}</b></div>
                            <div className="p-col-6" style={{textAlign: 'left'}}>
                                { subscription.config.status === "ACTIVE" && subscription.config.ends_on &&
                                    <>
                                    <span style={{color: 'green'}}>Ativo:</span>&nbsp;de { subscription.config.starts_on } a { subscription.config.ends_on } 
                                    </>
                                }
                                { subscription.config.status === "ACTIVE" && !subscription.config.ends_on &&
                                    <>
                                    <span style={{color: 'green'}}>Ativo:</span>&nbsp; a partir de { subscription.config.starts_on }
                                    </>
                                }
                                { subscription.config.status === "WAITING_PAYMENT" &&
                                    <>
                                    <span style={{color: 'grey'}}>
                                        Aguardando Pagamento<br/><br/>
                                        { subscription.config.payment.pagseguro && <>PagSeguro: { subscription.config.payment.pagseguro.transactionCode }</>}
                                    </span>
                                    </>
                                }
                            </div>
                            <div className="p-col-6" style={{textAlign: 'right'}}>
                            { subscription.config.status === "WAITING_PAYMENT" &&
                                <>
                                    { saving && <ProgressSpinner style={{width: '20px', height: '20px'}} strokeWidth="8"/> }
                                    { !saving && <>
                                        <Button disabled={saving} label={"Verificar Pagamento"} icon="pi pi-refresh" className="p-button-text" onClick={() => { checkStatus()}} /><br/>
                                        <Button disabled={saving} label={"Cancelar"} icon="pi pi-times" className="p-button-text" onClick={() => { cancelPendingPayment(subscription)}} />
                                    </>}
                                </>
                            }
                            { subscription.config.status === "ACTIVE" &&
                                <>
                                    { saving && <ProgressSpinner style={{width: '20px', height: '20px'}} strokeWidth="8"/> }
                                    { !saving && <>
                                        <Button disabled={saving} label={"Cancelar"} icon="pi pi-times" className="p-button-text" onClick={() => { cancelActive(subscription)}} />
                                    </>}
                                </>
                            }
                            </div>
                        </div>  
                    )
                }
                { 
                    currentSubscriptions.length === 0 &&
                        <div className="p-formgrid p-grid">
                            <div className="card">
                                Você não tem nenhuma assinatura.
                            </div>  
                        </div>
                }
                
                </>
                }
            </div>   
            
        </div>
    );
}

export default CurrentSubscription;